import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TextInput } from '@/components/ui/text-input'
import { useDebounce } from '@/hooks/use-debounce'

import * as S from './amenity-search.styled'

const SEARCH_DEBOUNCE_MS = 300

interface AmenitySearchProps {
  defaultValue?: string
  onSearch: (query: string) => void
}

export const AmenitySearch = ({ defaultValue = '', onSearch }: AmenitySearchProps) => {
  const { t } = useTranslation('reservations')
  const [value, setValue] = useState(defaultValue)
  const { debounce, reset } = useDebounce({ delay: SEARCH_DEBOUNCE_MS })

  const handleChange = (next: string) => {
    setValue(next)
    debounce(() => onSearch(next))
  }

  return (
    <S.Wrapper>
      <TextInput
        clearable
        aria-label={t('amenitySearch.placeholder')}
        icon={MagnifyingGlassIcon}
        placeholder={t('amenitySearch.placeholder')}
        size="small"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape' && value) {
            e.stopPropagation()
            reset()
            setValue('')
            onSearch('')
          }
        }}
      />
    </S.Wrapper>
  )
}
